import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { FixedAssetComponent } from '../fixed-asset/fixed-asset.component';
import { ViewAssetComponent } from '../view-asset/view-asset.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-fixed-asset-list',
  templateUrl: './fixed-asset-list.component.html',
  styleUrls: ['./fixed-asset-list.component.css']
})
export class FixedAssetListComponent implements OnInit {

  public menu_item_id = '44';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  acctTypes = [];
  displayedColumns = ['acct_number', 'asset_number', 'asset_name', 'asset_name_en', //'main_acct_name',
    'orginal_cost', 'start_date', 'def_age', 'service_year', 'book_value', 'depreciation_value', 'branch_name',
    'view', 'sale', 'edit', 'del'];
  displayedColumns2 = ['acct_number', 'asset_number', 'asset_name', 'asset_name_en', //'main_acct_name',
    'orginal_cost', 'start_date', 'def_age', 'service_year', 'book_value', 'depreciation_value', 'branch_name'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<FixedAssetComponent>;
  viewDialogRef: MatDialogRef<ViewAssetComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'fixed_asset', 'main_acct_no': '', 'asset_name': '', 'asset_number': '',
    'branch_id': '0', 'title': 'قائمة الأصول الثابتة'
  };

  branchList = [];

  Fixed_Asset_List; Success_Msg; Error_Msg; Del_Msg;
  Main_Acct_Type; Name; Asset_No;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Fixed_Asset_List').subscribe((res: string) => {
      this.Fixed_Asset_List = res;
    });
    this.model['title'] = this.Fixed_Asset_List;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Main_Acct_Type').subscribe((res: string) => {
      this.Main_Acct_Type = res;
    });

    translate.get('Name').subscribe((res: string) => {
      this.Name = res;
    });

    translate.get('Asset_No').subscribe((res: string) => {
      this.Asset_No = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    // this.acctTypes = [];
    // let query = this.queryList.all_mainAcct + " AND `acct_type_no` = '2'";
    // let obj = { cmd: 'getList', query: query };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.acctTypes = data.data['list'];
    //   });

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });


  }

  search() {
    let condition = "";

    if (this.model['main_acct_no'] != '')
      condition += " AND `fixed_asset`.`main_acct_no` = '" + this.model['main_acct_no'] + "'";

    if (this.model['asset_name'] != '')
      condition += " AND (`fixed_asset`.`asset_name` LIKE '%" + this.model['asset_name'] +
        "%' OR `fixed_asset`.`asset_name_en` LIKE '%" + this.model['asset_name'] + "%')";

    if (this.model['asset_number'] != '')
      condition += " AND `fixed_asset`.`asset_number` LIKE '%" + this.model['asset_number'] + "%'";

    if (this.model['branch_id'] != '0')
      condition += " AND `fixed_asset`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '0') {
      let index = 1;
      let list_length = this.branchList.length;

      condition += " AND `fixed_asset`.`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '0') {
          if (index < list_length)
            condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      condition += ")";
    }

    // let query = "SELECT `fixed_asset`.*, `main_acct`.`main_acct_name`, '' AS `service_year`, '' AS `book_value`, '' AS `depreciation_value`" +
    //   "FROM `fixed_asset`, `main_acct` WHERE `fixed_asset`.`main_acct_no` = `main_acct`.`main_acct_number`" +
    //   condition + " AND `fixed_asset`.`status` = '1' AND `fixed_asset`.`branch_id` = '"
    //   + this.applicationConstants.user_branch_info.user_branch_id + "'";

    let query = "SELECT `fixed_asset`.*, '' AS `service_year`, '' AS `book_value`, '' AS `depreciation_value`, " +
      "`branch`.`branch_name`, `branch`.`branch_name_en`FROM `fixed_asset`, `branch` WHERE `fixed_asset`.`status` = '1'" + 
      " AND `fixed_asset`.`branch_id` = `branch`.`branch_id`" + condition;

    let obj = { cmd: 'getList', query: query };
    // console.log(query);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        data.data['list'].forEach(element => {
          let start_date = new Date(element.start_date);
          let start_year = start_date.getFullYear();
          let today_date = new Date();
          let year = today_date.getFullYear();
          let percent = Number(element.depr_percent) / 100;
          element.service_year = Number(year) - Number(start_year);
          element.depreciation_value = (Number(element.orginal_cost) * percent) * Number(element.service_year);
          element.book_value = Number(element.orginal_cost) - Number(element.depreciation_value);
          element.start_date = (element.start_date).substring(0, 10);
        });
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newAsset() {
    this.addDialogRef = this.dialog.open(FixedAssetComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="33%"> ' + this.Main_Acct_Type + ': ';
    if (this.model['main_acct_no'] != '') {
      this.acctTypes.forEach(element => {
        if (element.main_acct_number == this.model['main_acct_no'])
          html_data += element.main_acct_name + ' (' + this.model['main_acct_no'] + ')';
      });
    }
    html_data += '</td>';
    html_data += '<td width="33%"> ' + this.Name + ': ' + this.model['asset_name'] + '</td>';
    html_data += '<td width="33%"> ' + this.Asset_No + ': ' + this.model['asset_number'] + '</td></tr></table>';

    let table = (document.getElementById('asset_table2') as HTMLTableElement);
    let form = (document.getElementById('form1') as HTMLFormElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  view(row) {

    let dialog_data = {
      'acct_number': row.acct_number,
      'main_acct_no': row.main_acct_no,
      'asset_name': row.asset_name,
      'asset_name_en': row.asset_name_en,
      'start_date': row.start_date,
      'depr_percent': row.depr_percent,
      'depreciation_value': row.depreciation_value,
      'book_value': row.book_value,
      'service_year': row.service_year,
      'def_age': row.def_age,
      'asset_number': row.asset_number,
      'orginal_cost': row.orginal_cost
    };

    this.viewDialogRef = this.dialog.open(ViewAssetComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.viewDialogRef
      .afterClosed()
      .subscribe(result => {
      });

  }

  sale(row) {

  }

  editAsset(row) {
    let dialog_data = {
      'table_name': 'fixed_asset', 'asset_id': row.asset_id,
      'main_acct_no': row.main_acct_no,
      'asset_name': row.asset_name,
      'asset_name_en': row.asset_name_en,
      'asset_number': row.asset_number,
      'acct_number': row.acct_number,
      'asset_desc': row.asset_desc,
      'orginal_cost': row.orginal_cost,
      'start_date': row.start_date, //'start_date_d': new Date(row.start_date),
      'def_age': row.def_age,
      'sale_scrap_cost': row.sale_scrap_cost,
      'credit_acct_no': row.credit_acct_no,
      'depr_percent': row.depr_percent,
      'comment': row.comment,
      'key': 'asset_id',
      'flag': 'update',
      'is_account': row.is_account,
      'branch_id': row.branch_id
    };
    this.addDialogRef = this.dialog.open(FixedAssetComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });

  }

  delAsset(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'asset_id': row.asset_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }

  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
